export default __webpack_public_path__ + "static/media/ten_of_swords.022b19fc.png";